import client from "@/lib/glossyApi";

const GA_ID = process.env.REACT_APP_GA_ID;
const CONSENT_KEY = "sme-cookie-consent";

export const hasConsent = () => {
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY) || "null")?.choice === "all"; } catch { return false; }
};

// Google tag with Consent Mode v2: always loads (so Google detects it), but analytics
// storage stays DENIED — no cookies, no tracking — until the reader accepts the banner.
export function initGA() {
  if (!GA_ID || window.__smeGA) return;
  window.__smeGA = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
  if (hasConsent()) grantAnalyticsConsent();
}

export function grantAnalyticsConsent() {
  if (window.gtag) window.gtag("consent", "update", { analytics_storage: "granted" });
}

export function trackPage(path) {
  if (window.gtag && GA_ID) {
    window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
  }
  // S/ME's own cookieless reader counter — public pages only, never the Studio.
  if (!path.startsWith("/admin") && !path.startsWith("/portal") && !path.startsWith("/studio")) {
    client.post("/track/view", { path }).catch(() => {});
  }
}
